import { AxiosError } from 'axios';

export function getError(e: unknown) {
	return e instanceof Error
		? {
				message: e.message || '',
				info: e instanceof AxiosError ? e.response?.data : { error: e },
		  }
		: e;
}
